import { creditNotesTypes } from "redux/reducers/creditNotes/creditNotesTypes";
import { api_post, api_get, PROYECT } from "services/api";
import { startRequestComp, stopRequestComp, setSnackbar } from "../search/searchActions";
import { saveAs } from 'file-saver';
import axios from "axios";
import { getErrorBlob } from "helpers/extractError";

const {
  SET_CREDIT_NOTES_FILTERS,
  GET_CREDIT_NOTES_SAT_USAGES,
  GET_CREDIT_NOTES,
  GET_CLIENT_CREDIT_NOTES,
  SELECT_ALL_NOTE_TO_CFDI,
  DESELECT_ALL_NOTE_TO_CFDI,
  TOGGLE_NOTE_TO_CFDI,
  DO_CREDIT_NOTES,
  CLEAR_CREDIT_NOTES,
  GET_DATA_FISCAL,
} = creditNotesTypes

export const getSatUsages = () => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/sat/cfdi_uses`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingCreditNotes'))
    await api_get(url).then(resp => {
      dispatch({
        type: GET_CREDIT_NOTES_SAT_USAGES,
        payload: resp
      })
    }).catch(error => dispatch(setSnackbar(error ? error : "Error contacte al administrador")))
    dispatch(stopRequestComp('loadingCreditNotes'))
  }
}

export const getClientsWithPendingNotes = (start, end, stations, name) => {
  let stationUrl = "";
  stations.forEach(station => {
    stationUrl = `${stationUrl}&stations=${station.id}`;
  });
  const url = `${process.env.REACT_APP_URL}${PROYECT}/notes/credit-stamp/pending-customers?name=${name}&start=${start}&end=${end}${stationUrl}`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingCreditNotes'))
    await api_get(url).then(resp => {
      if (!resp.length) dispatch(setSnackbar("No se encontraron resultados", "warning"))
      dispatch({
        type: GET_CREDIT_NOTES,
        payload: { response: resp, name }
      })
    }).catch(error => dispatch(setSnackbar(error)))
    dispatch(stopRequestComp('loadingCreditNotes'))
  }
}

export const getCreditNotesByClient = (idCustomer, start, end, stations, openModal = null) => {
  let stationUrl = "";
  stations.forEach(station => {
    stationUrl = `${stationUrl}&stations=${station.id}`;
  });
  const url = `${process.env.REACT_APP_URL}${PROYECT}/notes/credit-stamp/pending-notes?idCustomer=${idCustomer}&start=${start}&end=${end}${stationUrl}`

  return async (dispatch) => {
    dispatch(startRequestComp('loadingCreditNotesActions'))
    await api_get(url).then(resp => {
      dispatch({
        type: GET_CLIENT_CREDIT_NOTES,
        payload: resp[0]
      })
      openModal && openModal()
    }).catch(error => dispatch(setSnackbar(error ? error : "Error contacte al administrador")))
    dispatch(stopRequestComp('loadingCreditNotesActions'))
  }
}


export const doCreditNotes = (id, form, action = null) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/notes/credit-stamp`
  const fileName = `Factura_Crédito_${form.customer}_${form.date}.pdf`;
  let urlPdf
  return async (dispatch) => {
    dispatch(startRequestComp('loadingCreditNotesCreate'))
    await api_post(url, form).then(resp => {
      dispatch({
        type: DO_CREDIT_NOTES,
        payload: {
          id, count: form.ids.length
        }
      })
      dispatch(setSnackbar(resp?.message || 'Las notas se han timbrado con éxito', 'success'))
      urlPdf = resp.url
      action && action()
    }).catch(error => {
      dispatch(setSnackbar(error))
    })
    try {
      if (urlPdf) {
        const pdfResponse = await axios.get(urlPdf, { responseType: "blob", })
        saveAs(pdfResponse.data, fileName)
      }
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)))
    }
    dispatch(stopRequestComp('loadingCreditNotesCreate'))
  }
}

export const getDataFiscal = (idCustomer, idStation) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/notes/credit-stamp/fiscal-customer?idCustomer=${idCustomer}&idStation=${idStation}`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingCreditNotesCreate'))
    try {
      const resp = await api_get(url)
      dispatch({
        type: GET_DATA_FISCAL,
        payload: resp
      })
      dispatch(stopRequestComp('loadingCreditNotesCreate'))
      return resp
    } catch (err) {
      dispatch(setSnackbar(err))
      dispatch(stopRequestComp('loadingCreditNotesCreate'))
      return false
    }
  }
}

export const clearCreditNotes = () => ({
  type: CLEAR_CREDIT_NOTES,
})

export const selectAllNoteToCfdi = (ids) => ({
  type: SELECT_ALL_NOTE_TO_CFDI,
  payload: ids
})

export const deselectAllNoteToCfdi = () => ({
  type: DESELECT_ALL_NOTE_TO_CFDI
})

export const toggleNoteToCfdi = (id, folio) => ({
  type: TOGGLE_NOTE_TO_CFDI,
  payload: { id, folio }
});

export const setCreditNotesFilters = (key = "", data) => ({
  type: SET_CREDIT_NOTES_FILTERS,
  payload: { data, key }
})